<template>
  <div class="filters">
    <div class="filter">
      <div class="filter_item">
        <div class="wrap_titler">
          <div class="titler">Период</div>
          <div
            v-if="hasDate"
            class="clear"
            @click="clearDate"
          >
            <Icon name="close" />
          </div>
        </div>

        <v-menu
          v-model="menuDate"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="rel" v-bind="attrs" v-on="on">
              <v-text-field
                v-model="rangeText"
                readonly
                class="input_custom input_range"
                hide-details
                height="40"
                dense
              />
              <Icon class="abs" name="calendar"/>
            </div>
          </template>
          <v-card class="pa-2 picker-card">
<!-- оставляем header-color="white", чтобы фон был белым -->
<v-date-picker
  v-model="dateRange"
  locale="ru"
  :first-day-of-week="1"
  range
  color="#FED500"
  header-color="white"    
  light
  :show-current="true"
  class="picker-fix"     
  @change="saveDate"
/>

            <div class="d-flex mt-2">
              <v-text-field
                v-model="filters.startTime"
                type="time"
                hide-details dense
                class="mr-2 time-field"
              />
              <v-text-field
                v-model="filters.endTime"
                type="time"
                hide-details dense
                class="time-field"
              />
            </div>
            <v-btn block class="ok-btn mt-2" @click="saveDate">OK</v-btn>
          </v-card>
        </v-menu>
      </div>
      <div
        v-if="showScript"
        class="filter_item"
      >
        <div class="wrap_titler">
          <div class="titler">Скрипт обзвона</div>
          <div
            v-if="filters.script"
            class="clear"
            @click="filters.script = null"
          >
            <Icon name="close" />
          </div>
        </div>

        <v-combobox
          v-model="filters.script"
          :items="selects.scripts || []"
          item-text="name"
          item-value="id"
          dense
          hide-details
          clearable
          placeholder="Выберите"
          class="input_custom"
        />
      </div>

      <div
        v-if="showSource"
        class="filter_item"
      >
        <div class="wrap_titler">
          <div class="titler">Источник</div>
          <div
            v-if="filters.source"
            class="clear"
            @click="filters.source = null"
          >
            <Icon name="close" />
          </div>
        </div>

        <v-combobox
          v-model="filters.source"
          :items="selects.sources || []"
          item-text="name"
          item-value="id"
          dense
          hide-details
          clearable
          placeholder="Выберите"
          class="input_custom"
        />
      </div>

      <div
        v-if="showCall"
        class="filter_item"
      >
        <div class="wrap_titler">
          <div class="titler">Обзвон</div>
          <div
            v-if="filters.call"
            class="clear"
            @click="filters.call = null"
          >
            <Icon name="close" />
          </div>
        </div>

 <v-combobox
   v-model="filters.call"
   :items="selects.calls || []"
   :item-text="itemLabel"
   :item-value="itemLabel" 
    dense hide-details clearable
    placeholder="Выберите"
    class="input_custom"
  />
      </div>

      <div
        v-if="showBase"
        class="filter_item"
      >
        <div class="wrap_titler">
          <div class="titler">База номеров</div>
          <div
            v-if="filters.base"
            class="clear"
            @click="filters.base = null"
          >
            <Icon name="close" />
          </div>
        </div>

 <v-combobox
  v-model="filters.base"
   :items="selects.bases || []"
   :item-text="itemLabel"
   :item-value="itemLabel"
    dense hide-details clearable
    placeholder="Выберите"
    class="input_custom"
  />
      </div>

    </div>

    <div class="filter">



    <div
      v-if="page_type === 'reports'"
      class="filter_item ml-4"
    >
      <div class="only-successful-with-tip">
        <v-checkbox
          v-model="filters.only_successful"
          hide-details
          label="Только успешные"
          dense
        />
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              small
              class="tip-icon"
            >mdi-help-circle-outline</v-icon>
          </template>
          <span>Цели, отмеченные «Успешный звонок»</span>
        </v-tooltip>
      </div>
    </div>

      <div class="filter_item ml-4">
        <v-btn
          class="apply-btn ml-4"
          height="40"
          @click="emitFilters"
        >
          Применить
        </v-btn>
      </div>

      <div class="filter_item ml-2">
        <v-btn
          class="export-btn ml-2"
          height="40"
          @click="handleExport"
        >
          Экспорт
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialogGroup" max-width="420">
      <v-card>
        <v-card-title class="headline pb-0">Группировка для экспорта</v-card-title>
        <v-card-text>
          <v-radio-group v-model="grouping" column>
            <v-radio label="Без группировки" value="none" />
            <v-radio label="Источник"        value="source" />
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="justify-end pr-4 pb-4">
          <v-btn text @click="dialogGroup = false">Отмена</v-btn>
          <v-btn color="#FED500" dark @click="confirmExport">Выгрузить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Icon from '../SetIcon.vue'

export default {
  name: 'ReportsFilter',
  components: { Icon },
  props: {
    page_type: {
      type: String,
      required: true
    },
    selects: {
      type: Object,
      default: () => ({})
    },
    callback: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      menuDate: false,
      dateRange: [],
      dialogGroup: false,
      grouping: 'none',
      filters: {
        script: null,
        source: null,
        call: null,
        base: null,
        only_successful: false,
        startDate: null,
        startTime: '00:00',
        endDate: null,
        endTime: '23:59'
      }
    }
  },
  computed: {
    showScript () {
      return ['reports', 'sources', 'bases'].includes(this.page_type)
    },
    showSource () {
      return ['reports', 'scripts', 'bases'].includes(this.page_type)
    },
    showCall () {
      return ['reports', 'scripts', 'sources', 'bases'].includes(this.page_type)
    },
    showBase () {
      return ['reports', 'scripts', 'sources'].includes(this.page_type)
    },
    hasDate () {
      return !!(this.filters.startDate && this.filters.endDate)
    },
    rangeText () {
      if (!this.filters.startDate || !this.filters.endDate) {
        return 'За сегодня'
      }
      const fmt = (d, t) => {
        const [y, m, day] = d.split('-')
        return `${day}.${m}.${y} ${t}:00`
      }
      return (
        fmt(this.filters.startDate, this.filters.startTime) +
        ' – ' +
        fmt(this.filters.endDate,   this.filters.endTime)
      )
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.emitFilters()
      }
    }
  },
  created () {
    this.$set(this.$vuetify.lang.locales.en.datePicker, 'itemsSelected', '{0} выбрано')
    this.$set(this.$vuetify.lang.locales.ru.datePicker, 'itemsSelected', '{0} выбрано')
    this.$vuetify.lang.current = 'ru'
  },
  methods: {

itemLabel (item) {
      return typeof item === 'object' && item
        ? item.name || item.label || item.value || item.id
        : String(item)                                
    },
    saveDate () {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filters.startDate = this.dateRange[0]
        this.filters.endDate   = this.dateRange[1]
      } else {
        this.filters.startDate = null
        this.filters.endDate   = null
      }
      this.menuDate = false
    },
    clearDate () {
      this.dateRange = []
      this.filters.startDate = null
      this.filters.endDate = null
    },
    emitFilters () {
      const payload = { ...this.filters }
      if (this.callback) {
        this.callback(payload)
      }
      this.$emit('updateFilter', payload)
    },
    handleExport () {
      if (['reports', 'scripts', 'bases'].includes(this.page_type)) {
        this.dialogGroup = true
      } else {
        this.sendExport('none')
      }
    },
    confirmExport () {
      this.dialogGroup = false
      this.sendExport(this.grouping)
    },
    sendExport (groupingValue) {
      const payload = { ...this.filters, group_by: groupingValue === 'source' ? 'source' : null }
      this.$emit('export', payload)
    }
  }
}
</script>

<style scoped>
/* ────────────────────  DATE-PICKER  ──────────────────── */
/* ---- Календарь внутри .picker-card ---- */
::v-deep(.picker-card){

  /* титульная часть (год и «N выбрано») */
  .v-date-picker-title{
    background:#FFFFFF !important;
    padding:24px 24px 12px !important;
  }
  .v-date-picker-title__year{
    font:400 18px/22px 'inherit';
    color:#757575 !important;
  }
  .v-date-picker-title__date,
  .v-date-picker-title__items-selected{
    font:700 36px/40px 'inherit';
    color:#2B2D33 !important;
  }

  /* шапка с месяцем + стрелками */
  .v-date-picker-header{
    background:#FFFFFF !important;
    color:#2B2D33 !important;
  }
  .v-date-picker-header .v-btn,
  .v-date-picker-header__value{
    color:#2B2D33 !important;
  }

  /* сами даты */
  .v-date-picker-table--date .v-btn:not(.v-btn--active){
    background:#FFFFFF !important;
    color:#2B2D33 !important;
  }
  .v-btn.v-btn--active{
    background:#FED500 !important;
    color:#2B2D33 !important;
  }
  .v-btn.v-btn--today:not(.v-btn--active){
    color:#FED500 !important;
  }

  /* поля времени и кнопка ОК */
  .time-field .v-input__slot{
    background:#FFFFFF !important;
    border:2px solid #FED500 !important;
    border-radius:8px !important;
    color:#2B2D33 !important;
    font-weight:400 !important;
  }
  .ok-btn{
    background:#FFFFFF !important;
    border:2px solid #FED500 !important;
    border-radius:8px !important;
    color:#2B2D33 !important;
    font-weight:600 !important;
  }

  /* защита от auto-white text Vuetify */
  .white--text{ color:#2B2D33 !important; }
}


/* ────────────────────  ФИЛЬТРЫ  ──────────────────── */
.filters {
  display:flex;
  align-items:center;
  justify-content:space-between;
  background:#FFF4E8;
  padding:22px 32px;
  border-radius:8px 8px 0 0;
}
@media (max-width:800px){
  .filters { flex-direction:column; border-radius:0; }
}

.filter       { display:flex; align-items:flex-end; }
.filter_item  { display:flex; flex-direction:column; margin-right:16px; }

.wrap_titler  { display:flex; align-items:center; justify-content:space-between; margin-bottom:4px; }
.titler       { font-size:12px; line-height:14px; color:#757575; }
.clear        { cursor:pointer; display:flex; align-items:center; }

.rel          { position:relative; }
.abs          { position:absolute; top:13px; right:13px; }
.input_range  { min-width:250px; }

.only-successful-with-tip { display:flex; align-items:baseline; }
.tip-icon { margin-left:1px; cursor:pointer; position:relative; top:-22px; }

.apply-btn, .export-btn{
  background:#FFFFFF !important;
  border:1px solid #FED500 !important;
  border-radius:8px !important;
  color:#2B2D33 !important;
  font-weight:600;
  font-size:15px;
  line-height:120%;
  text-transform:none;
  padding:10px 20px;
}
.apply-btn--disabled, .export-btn--disabled{
  opacity:.5; pointer-events:none;
}
::v-deep(.fix-white-title) {
  /* заголовок с годом/«N выбрано» */
  .v-picker__title          { color:#2B2D33 !important; }
  /* внутри него Vuetify вставляет .white--text  →  перебиваем */
  .white--text               { color:#2B2D33 !important; }
}
::v-deep .picker-fix .white--text,
::v-deep .picker-fix .v-picker__title { color:#2B2D33 !important; }
::v-deep .time-field .v-input__slot {
  border: 2px solid #FED500 !important;   /* рамка вокруг всего поля */
  border-radius: 8px !important;
}
</style>
